/**
 * @file: index.ts
 * @author: eric <eric.blueplus@gmail.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

require('./order');
require('./pre-inspection');
require('./inspection');
require('./quotation');
require('./construction');
require('./delivery-check');
require('./sampling-check');
